import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SEO from '../common/SEO'
import HeaderKorlo from '../common/header/HeaderKorlo'
import { FiMail, FiMapPin, FiArrowRight } from 'react-icons/fi'
import emailjs from 'emailjs-com'

const Result = () => {
  return (
    <p className='success-message'>
      Your message has been sent successfully. We'll be in touch soon.
    </p>
  )
}

const KorloContactPage = () => {
  const [result, showResult] = useState(false)

  const sendEmail = (e) => {
    e.preventDefault()
    emailjs
      .sendForm(
        'service_p4x3hv8',
        'template_jgfr42f',
        e.target,
        'user_jrfTH2e0Ely35ZCVFdT9S'
      )
      .then(
        (result) => {
          console.log(result.text)
        },
        (error) => {
          console.log(error.text)
        }
      )
    e.target.reset()
    showResult(true)
    setTimeout(() => {
      showResult(false)
    }, 5000)
  }

  return (
    <>
      <SEO title='Contact - Korlo AI' />
      <main className='page-wrapper'>
        <HeaderKorlo btnStyle='btn-small' />

        {/* Contact Hero */}
        <section className='korlo-contact-hero'>
          <div className='container'>
            <span className='contact-label'>Contact</span>
            <h1 className='contact-title'>Get in Touch</h1>
            <p className='contact-subtitle'>
              Have a question or want to learn more about Korlo AI?
              We'd love to hear from you.
            </p>
          </div>
        </section>

        {/* Contact Content */}
        <section className='korlo-contact-content'>
          <div className='container'>
            <div className='row justify-content-center g-4'>
              <div className='col-lg-4 col-md-6'>
                <div className='contact-info-card'>
                  <div className='contact-icon'>
                    <FiMail />
                  </div>
                  <h4 className='contact-info-title'>Email</h4>
                  <p className='contact-info-text'>
                    <a href='mailto:info@korlo.ai'>info@korlo.ai</a>
                  </p>
                </div>
              </div>
              <div className='col-lg-4 col-md-6'>
                <div className='contact-info-card'>
                  <div className='contact-icon'>
                    <FiMapPin />
                  </div>
                  <h4 className='contact-info-title'>Location</h4>
                  <p className='contact-info-text'>Ann Arbor, Michigan</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className='row justify-content-center'>
              <div className='col-lg-8'>
                <div className='contact-form-wrapper'>
                  <h3 className='form-heading'>Send Us a Message</h3>
                  <p className='form-subheading'>
                    Fill out the form below and we'll get back to you as soon as possible.
                  </p>
                  <form className='contact-form' onSubmit={sendEmail}>
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='form-group'>
                          <input
                            type='text'
                            name='fullname'
                            placeholder='Your Name'
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='form-group'>
                          <input
                            type='email'
                            name='email'
                            placeholder='Email Address'
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-group'>
                      <input
                        type='text'
                        name='subject'
                        placeholder='Subject'
                        required
                      />
                    </div>
                    <div className='form-group'>
                      <textarea
                        name='message'
                        placeholder='Your Message'
                        required
                      />
                    </div>
                    <div className='form-group'>
                      <button type='submit' className='btn-primary-korlo'>
                        Send Message <FiArrowRight />
                      </button>
                    </div>
                    {result && <Result />}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className='korlo-footer'>
          <div className='container'>
            <div className='footer-inner'>
              <span className='footer-copyright'>
                &copy; {new Date().getFullYear()} Korlo Holdings LLC
              </span>
              <div className='footer-links'>
                <Link to='/about'>About</Link>
                <Link to='/contact'>Contact</Link>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </>
  )
}

export default KorloContactPage
